import React, { useState, useEffect, useContext } from "react";
import edit from "../../assets/media/icons/edit-2.svg";
import profil from "../../assets/media/images/Frame.svg";
import { AppContext } from "../../AppContextProvider";

const ImageCrop = (props) => {
  const context = useContext(AppContext);
  const [preview, setPreview] = useState();

  const openModal = () => {
    context.openModal("imageupload", "", {
      // a Modal/AvatarCropper onDone ezt fogja hívni (File/Blob mehet)
      savePhotoAsFile: (blobOrFile) => props.savePhotoAsFile?.(blobOrFile),
    });
  };

  useEffect(() => {
    if (props.profileData) setPreview(props.profileData);
  }, [props.profileData]);

  return (
    <div className="flex justify-center items-center">
      <div className="editable-username">
        <div className="profile">
          <div className="overlap-group">
            {preview ? (
              <>
                <img src={preview} height={192} width={192} className="user-profile" alt="" />
                <img className="icon-button-outlined" alt="Icon button outlined" src={edit} onClick={openModal} />
              </>
            ) : (
              <>
                <img className="user-profile" alt="User Profile" src={profil} />
                <img className="icon-button-outlined" alt="Icon button outlined" src={edit} onClick={openModal} />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageCrop;
